<template lang="html">
  <div class="main" v-loading="loading" element-loading-background="rgba(255, 255, 255, 0)">
    <i class="material-icons none" v-if="pkgs.length === 0 && !loading">
      cloud_upload
    </i>
    <div class="main-cell">
      <div class="pkg-list-title">
        <div class="sender-name">
          {{message.SInfo.l05}}
        </div>
        <div class="pkg-name">
          {{message.Al119}}
        </div>
        <div class="pkg-title" :title="message.Fl112">
          {{message.Fl112}}
        </div>
        <div class="pkg-size">
          {{message.Sl229}}
        </div>
        <div class="pkg-time">
          {{message.Sl228}}
        </div>
      </div>
      <comp-pkg
        v-for="(pkg, index) in pkgs"
        :key = "index"
        :disable="pkg.disable"
        :state="pkg.state"
        :id="pkg.id"
        :sender='pkg.sender'
        :recipient='pkg.recipient'
        :title="pkg.title"
        :time="pkg.time"
        :size="pkg.size"
        :notes="pkg.notes"
        :weight="pkg.weight"
        :percent="pkg.percent"
        :fileNum="pkg.fileNum"
        :index="index"
        :downloadTimes="pkg.downloadTimes"
        @deleteSuccess="deletea(index)"
        @updateSuccess="updatea(index)"
        @removeActive="removeAllActive(index)"
        :timeWord="pkg.timeWord"
        :deletion="pkg.deletion"
        :imgUrl="pkg.imgUrl"
        :expire="pkg.expire"
        :isActive="pkg.isActive"
        :userIdList="pkg.userIdList"
        :userRole="userRole"
        :recordNum="pkg.recordNum"
      >
      </comp-pkg>
    </div>
    <div id="loadMoreElement"></div>
    <span class="" v-show="loadMore">
      {{message.Sl103}}
    </span>
    <span class="more" v-show="loadEnd && pkgs.length >= 20">
      {{message.Sl104}}
    </span>
  </div>
</template>

<script>
import CompPkg from '@/components/box/pkgHistory.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    CompPkg
  },
  created () {
    this.$store.dispatch('addProject', localStorage.getItem('projectId'))
  },
  computed: {
    ...mapGetters({
      scroll: 'scroll',
      space: 'space',
      size: 'size'
    }),
    // style: function () {
    //   var data = {
    //     minHeight: this.size.height - 105 + 'px'
    //   }
    //   return data
    // }
  },
  watch: {
    scroll: function () {
      if (this.loading) {
        return
      }
      var clientHeight = document.documentElement.clientHeight
      var scrollTop = this.getScrollTop()
      // if (this._global.config.browser === 'qt') {
      //   scrollTop = document.body.scrollTop
      // }
      var scrollHeight = document.documentElement.scrollHeight
      if (clientHeight + scrollTop >= scrollHeight) {
        this.moreContent()
      }
    },
    space: function () {
      this.num = 1
      this.pkgs = []
      this.maps = new Map()
      this.packagesList()
      this.setRole()
    }
  },
  data () {
    var maps = new Map()
    return {
      message: {
        Sl103: this.$lang.ui.system.l103,
        Sl104: this.$lang.ui.system.l104,
        SInfo: this.$lang.ui.system.pkgInfo,
        Fl112: this.$lang.ui.form.l112,
        Al119: this.$lang.ui.app.l119,
        Sl228: this.$lang.ui.system.l228,
        Sl229: this.$lang.ui.system.l229,
      },
      loading: false,
      num: 1,
      state: 'upload',
      type: 'sender',
      loadMore: false,
      pkgs: [],
      maps: maps,
      loadEnd: false,
      position: '',
      maxNum: '',
      userRole: 0,
      timeDate: {
        today: {
          active: false,
          value: this.$lang.ui.system.date.l0
        },
        yesterday: {
          active: false,
          value: this.$lang.ui.system.date.l1
        },
        week: {
          active: false,
          value: this.$lang.ui.system.date.l2
        },
        month: {
          active: false,
          value: this.$lang.ui.system.date.l3
        },
        monthList: [
          [false, this.$lang.ui.system.date.l01],
          [false, this.$lang.ui.system.date.l02],
          [false, this.$lang.ui.system.date.l03],
          [false, this.$lang.ui.system.date.l04],
          [false, this.$lang.ui.system.date.l05],
          [false, this.$lang.ui.system.date.l06],
          [false, this.$lang.ui.system.date.l07],
          [false, this.$lang.ui.system.date.l08],
          [false, this.$lang.ui.system.date.l09],
          [false, this.$lang.ui.system.date.l10],
          [false, this.$lang.ui.system.date.l11],
          [false, this.$lang.ui.system.date.l12]
        ]
      }
    }
  },
  mounted () {
    if (!localStorage.getItem('projectId')) {
      return
    }
    this.$store.dispatch('showBox', 'history')
    // Set to true so that after the first package list fetching, auto fill package list until browser height is reached
    this.packagesList(true)
    this.setRole()
    window.removeEventListener('scroll', this._global.moreContent)
    window.addEventListener('scroll', this._global.moreContent)
  },
  methods: {
    getScrollTop () {
      return window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
    },
    setRole () {
      if (!this.space.id) {
        return
      }
      this.$api.getUserRole(this.space.id, response => {
        this.$store.dispatch('addRole', response.permission.role)
        this.userRole = response.permission.operation
      })
    },
    removeAllActive (index) {
      for (var i = 0; i < this.pkgs.length; i++) {
        if (i !== index) {
          this.pkgs[i].isActive = ''
        }
      }
      if (this.pkgs[index].isActive === '') {
        this.pkgs[index].isActive = 'active'
      } else {
        this.pkgs[index].isActive = ''
      }
    },
    packagesList (autoFetchNext) {
      if (!this.space.id) {
        return
      }
      this.loading = true
      this.timeDate.today.active = false
      this.timeDate.yesterday.active = false
      this.timeDate.week.active = false
      this.timeDate.month.active = false
      this.$store.dispatch('sentFile', false)
      for (var z = 0; z < this.timeDate.monthList.length; z++) {
        this.timeDate.monthList[z][0] = false
      }
      this.$http.get('/cydex/api/v1/packages', { params: {
        'project_id': this.space.id,
        is_del: 1,
        'with_receivers': 1,
        'with_sender': 1,
        'page_num': this.num,
        'page_size': 20
      } })
        .then(response => {
          this.loading = false
          this.loadMore = false
          this.loadEnd = false
          this.maxNum = Math.ceil(response.data.total_num / 20)
          for (var i = 0; i < response.data.packages.length; i++) {
            if (response.data.packages[i].expiration) {
              if (response.data.packages[i].expiration.expires === 0) {
                var expire = {
                  time: '-',
                  distance: ''
                }
              } else {
                expire = {
                  time: this._global.timeSwitch(response.data.packages[i].expiration.expire_at),
                  distance: this._global.dayAfterSwitch(response.data.packages[i].expiration.expire_at, 0)
                }
              }
            }
            let disable = false
            if (response.data.packages[i].is_disable) {
              disable = true
              var deletion = {
                id: response.data.packages[i].disable.by,
                is: true,
                name: response.data.packages[i].disable.by_name,
                type: 'user',
                time: ''
              }
            } else if (response.data.packages[i].is_deleted) {
              var dTime = this._global.dayAfterSwitch(response.data.packages[i].deletion.real_delete_expires, response.data.packages[i].deletion.deleted_at)
              if (response.data.packages[i].deletion.deleted_by === 'expires') {
                var dId = ''
                var dName = ''
                var type = 'expires'
              }
              if (response.data.packages[i].deletion.deleted_by === 'expires_after_download') {
                dId = ''
                dName = ''
                type = 'after'
              }
              if (response.data.packages[i].deletion.deleted_by === 'admin') {
                dId = ''
                dName = ''
                type = 'admin'
              }
              if (
                response.data.packages[i].deletion.deleted_by !== 'expires_after_download' &&
              response.data.packages[i].deletion.deleted_by !== 'expires' &&
              response.data.packages[i].deletion.deleted_by !== 'admin'
              ) {
                dId = response.data.packages[i].deletion.deleted_by
                dName = response.data.packages[i].deletion.deleted_by_name
                type = 'user'
              }
              deletion = {
                id: dId,
                is: true,
                name: dName,
                type: type,
                time: dTime
              }
            } else {
              deletion = {
                id: dId,
                is: false,
                name: '',
                type: '',
                time: ''
              }
            }
            if (response.data.packages[i].job_create_at) {
              var createTime = response.data.packages[i].job_create_at
            } else {
              createTime = response.data.packages[i].create_at
            }
            var t = this._global.timeMoreSwitch(createTime)
            var n = this._global.timeMoreSwitch(new Date() / 1000)
            if (t.year === n.year && t.month === n.month && t.date === n.date) {
              if (this.timeDate.today.active) {
                var timeWord = ''
              } else {
                timeWord = this.timeDate.today.value
                this.timeDate.today.active = true
              }
            } else {
              if (t.year === n.year && t.month === n.month && n.date - t.date === 1) {
                if (this.timeDate.yesterday.active) {
                  timeWord = ''
                } else {
                  timeWord = this.timeDate.yesterday.value
                  this.timeDate.yesterday.active = true
                }
              } else {
                if (t.year === n.year && t.month === n.month && n.day === t.day) {
                  if (this.timeDate.week.active) {
                    timeWord = ''
                  } else {
                    timeWord = this.timeDate.week.value
                    this.timeDate.week.active = true
                  }
                } else {
                  if (t.year === n.year && t.month === n.month) {
                    if (this.timeDate.month.active) {
                      timeWord = ''
                    } else {
                      timeWord = this.timeDate.month.value
                      this.timeDate.month.active = true
                    }
                  } else {
                    if (this.timeDate.monthList[t.month - 1][0]) {
                      timeWord = ''
                    } else {
                      timeWord = this.timeDate.monthList[t.month - 1][1]
                      this.timeDate.monthList[t.month - 1][0] = true
                    }
                  }
                }
              }
            }
            var size = this._global.trafficSwitch(response.data.packages[i].size)
            var num = response.data.packages[i].files_num_file || response.data.packages[i].files_num
            var recordNum = (
              response.data.packages[i].files_num - response.data.packages[i].files_num_dir_blank
            ) || response.data.packages[i].files_num
            if (response.data.packages[i].notes !== '') {
              var notes = response.data.packages[i].notes
            } else {
              notes = ''
            }
            if (response.data.packages[i].is_read) {
              var weight = 500
            } else {
              weight = 600
            }
            var downloadTimes = 0
            var imgUrl = ''
            const sender = {
              id: response.data.packages[i].sender.user.id,
              name: response.data.packages[i].sender.user.name
            }
            const recipient = []
            if (response.data.packages[i].receivers) {
              response.data.packages[i].receivers.map(value => {
                recipient.push({
                  name: value.user.name,
                  id: value.user.id,
                })
              })
            }
            var percent = parseInt(response.data.packages[i].sender.finished_size / response.data.packages[i].size * 100)
            this.maps.set(response.data.packages[i].id, percent)
            const state = response.data.packages[i].operation === 'd' ? 'download' : 'upload'
            this.pkgs.push({
              id: response.data.packages[i].id,
              state: state,
              sender: sender,
              recipient: recipient,
              title: response.data.packages[i].title,
              size: size,
              fileNum: num,
              time: this._global.timeSwitch(createTime),
              notes: notes,
              weight: weight,
              percent: percent,
              timeWord: timeWord,
              deletion: deletion,
              downloadTimes: downloadTimes,
              expire: expire,
              imgUrl: imgUrl,
              isActive: '',
              disable: disable,
              recordNum: recordNum,
            })
          }
          // if browser window height is not reached, auto fetch next records
          if (autoFetchNext) {
            // wait for package list to render so that we know the height
            this.$nextTick(this.autoMoreContent)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    updatea (index) {
      this.$http.get('/cydex/api/v1/packages/' + this.pkgs[index].id, {
        params: {
          op: 'upload',
          with_receivers: 1
        }
      })
        .then(response => {
          var name = '-'
          var nameNum = ''
          var imgUrl = response.data.receivers[0].user.pic_url
          var userIdList = []
          if (response.data.receivers.length > 1) {
            nameNum = '(' + response.data.receivers.length + ')'
          }
          for (var i = 0; i < response.data.receivers.length; i++) {
            userIdList.push({
              id: response.data.receivers[i].user.id,
              name: response.data.receivers[i].user.name
            })
            if (i === 0) {
              name = response.data.receivers[i].user.name
            } else {
              name = name + ',' + response.data.receivers[i].user.name
            }
          }
          this.pkgs[index].name = name
          this.pkgs[index].nameNum = nameNum
          this.pkgs[index].imgUrl = imgUrl
          this.pkgs[index].userIdList = userIdList
        })
    },
    moreContent (autoFetchNext) {
      this.num = this.num + 1
      if (this.num <= this.maxNum) {
        this.loadEnd = false
        this.loadMore = true
        this.packagesList(autoFetchNext)
      } else {
        this.loadEnd = true
      }
    },
    autoMoreContent () {
      let contentHeight = document.getElementById('loadMoreElement').getBoundingClientRect().y
      if (this.num <= this.maxNum && contentHeight < document.documentElement.clientHeight) {
        this.moreContent(true)
      }
    }
  }
}
</script>

<style scoped lang="css">
.main {
  position: relative;
  padding: 5px;
  min-height: calc(100% - 45px);
}
.main-cell {
  min-width: 570px;
}
.more {
  display: block;
  width: 100%;
  padding: 10px;
  font-style: italic;
  color: #9e9e9e;
  text-align: center;
}
.none {
  position: absolute;
  top: 48%;
  left: 50%;
  margin-top: -83px;
  margin-left: -82px;
  color: rgba(148, 170, 178, 0.4);
  font-size: 165px;
}
.pkg-list-title {
  position: relative;
  width: 100%;
  padding: 0 18px;
  height: 35px;
  line-height: 35px;
  margin-top: 20px;
  margin-bottom: 5px;
  font-weight: 600;
  background: #f4f4f4;
}
.sender-name {
  float: left;
  display: flex;
  margin-left: 5px;
  width: 100px;
}
.pkg-name {
  float: left;
  display: flex;
  text-transform: capitalize;
  margin-left: 20px;
  width: 180px;
}
.pkg-title {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 330px;
  right: 380px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.pkg-time {
  color: #666;
  width: 140px;
  float: right;
}
.pkg-size {
  color: #666;
  float: right;
  width: 198px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
